import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { StoreContext } from "../../store/store";
import { AppBar, Button, Grid, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AndroidIcon from "@material-ui/icons/Android";
import GoogleStore from "../../images/play_store.png";
import AppStore from "../../images/App_Store.png";
import HuaweiAppStore from "../../images/huawei_download_image.png";
import Mobiles2 from "../../images/Mobiles2.png";
import WebApp from "../../images/WebApp.png";
import AppleIcon from "@material-ui/icons/Apple";
import CircularProgress from "@material-ui/core/CircularProgress";

import logo from "../../images/MIE_Dark_Black.png";
// import logo_updated from "../../images/MIE_Logo_updated.png";
import Whatapp_QR from "../../images/whatsapp_QR.png";
import Discord_QR from "../../images/Discord_QR.png";
import Colors from "../../Config/Colors";
import TextTranslation from "../../Config/TextTranslation";
import facebook from "../../images/facebook.png";
import twitter from '../../images/twitter.png';
import instagram from '../../images/instagram.png';
import handshake from '../../images/handshake.png';
import { useHistory } from "react-router-dom";

import linkedin from '../../images/linkedin.png';
import tiktok from '../../images/tiktok.png';
import whatsapp from '../../images/whatsapp_svg.svg';
import whatsapp_white from '../../images/whatsapp.png';
import whatsapp_black from '../../images/whatsapp-black.png';
import youtube from '../../images/youtube.png';
import "./MainOverlay.css";
import { useEffect } from "react";
import { Observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "white",
  },
  fontRaleway: {
    fontsfontFamily: 'Raleway, sans-serif'
  },
  logo: {
    display: "flex",
    marginBottom: "3%",
    paddingTop: "5%",
    [theme.breakpoints.down("lg")]: {
      marginTop: "5%",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "10%",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "20%",
    },
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: Colors.primary,
    fontFamily: "Raleway, sans-serif",
    color: Colors.black,
    "&:hover": {
      backgroundColor: Colors.black,
    },
  },
}));

const MainOverlay = () => {
  const currentLocation = useLocation();
  const history = useHistory();
  const store = useContext(StoreContext);
  const classes = useStyles();
  const [load, setLoad] = useState(false); // button loader state
  const [menu, setMenu] = useState(false);

  console.log(window.navigator.userAgent)
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {

      // <Button  target="_blank" rel="noreferrer noopener">Download</Button>
    }

    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=minhaj.islamic.encyclopedia"

    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = "https://apps.apple.com/pk/app/minhaj-islamic-encyclopedia/id1609248178"

    }

    return "unknown";
  }
  // const RedirectPg=()=>{
  //   window.location.host==='download.minhaj.app' ? getMobileOperatingSystem():''
  // }
  const toggleMenu = () => {
    console.log(menu);
    if (menu == false) {
      setMenu(true)
    } else if (menu == true) {
      setMenu(false)
    }

  }
  // console.log( (getMobileOperatingSystem()));
  useEffect(() => {
    if (window.location.host === 'download.minhaj.app') {
      getMobileOperatingSystem()
    }

    console.log(window.location.host)
  }, [])
  return (
    <>
      <div className="bg-gradiant">
        {/* Header */}
        <header className="py-2 header-custom">
          <div className="container">
            {/* Logo and Menu Button for Mobile */}
            <div className="navbar-header col mr-4 d-block d-md-none pt-2">
              <button
                type="button"
                className="navbar-toggle collapsed border-0"
                onClick={toggleMenu}
              >
                <i className="fa fa-bars" aria-hidden="true"></i>
              </button>
            </div>

            {/* Main Navigation for larger screens */}
            <div className="navbar-header-custom justify-content-between align-items-center">
              <div className="d-flex justify-content-left align-items-center">
                <div className="logo">
                  <div className="d-flex main_logo">
                    <img
                      src={logo}
                      alt="Main Logo"
                      className="main_logo_style img-fluid img-responsive"
                    />
                  </div>
                </div>
                {/* Links */}
                <nav>
                  <ul className="list-unstyled d-flex mb-0">
                    <li className="mx-3">
                      <Link
                        to="/aboutus"
                        className={`${classes.link} text-decoration-none`}
                        style={{
                          color: 'black',
                          fontFamily:
                            store.langIndex == 0
                              ? "Raleway, sans-serif"
                              : store.langIndex == 1
                                ? "JameelNoori"
                                : "Arabic",
                          fontSize:
                            store.langIndex == 0
                              ? 17
                              : store.langIndex == 1
                                ? 15
                                : 13,
                        }}
                      >
                        {TextTranslation.about_us[store.langIndex]}
                      </Link>
                    </li>
                    <li className="mx-3">
                      <Link
                        to="/features"
                        className={`${classes.link} text-decoration-none`}
                        style={{
                          color: 'black',
                          fontFamily:
                            store.langIndex == 0
                              ? "Raleway, sans-serif"
                              : store.langIndex == 1
                                ? "JameelNoori"
                                : "Arabic",
                          fontSize:
                            store.langIndex == 0
                              ? 17
                              : store.langIndex == 1
                                ? 15
                                : 13,
                        }}
                      >
                        {TextTranslation.features[store.langIndex]}
                      </Link>
                    </li>
                    <li className="mx-3">
                      <Link
                        to="/contactus"
                        className={`${classes.link} text-decoration-none`}
                        style={{
                          color: 'black',
                          fontFamily:
                            store.langIndex == 0
                              ? "Raleway, sans-serif"
                              : store.langIndex == 1
                                ? "JameelNoori"
                                : "Arabic",
                          fontSize:
                            store.langIndex == 0
                              ? 17
                              : store.langIndex == 1
                                ? 15
                                : 13,
                        }}
                      >
                        {TextTranslation.suggestion_contact_us[store.langIndex]}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="main-buttons-header  gap-3 justify-content-center align-items-center" >
                <a target="_blank" style={{ border: '' }} className="p-0 d-block  text-decoration-none" rel="noreferrer noopener" href='https://wa.link/0cxply'>
                  <Button target="_blank"
                    className="Feedback-btn btn btn-radius d-flex justify-content-center align-items-center "
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{
                      border: '1px solid #247034',
                      color: '#247034',
                      backgroundColor: 'transparent'
                    }}
                  >
                    {load ? (
                      <CircularProgress
                        size={30}
                        style={{ color: Colors.primary }}
                      />
                    ) : (
                      <span
                        style={
                          store.langIndex == 0
                            ? { fontFamily: "Raleway, sans-serif !important", fontSize: 12 }
                            : store.langIndex == 1
                              ? { fontFamily: "jameelNoori !important", fontSize: 10 }
                              : { fontFamily: "Arabic !important", fontSize: 10 }
                        }
                        className="d-flex justify-content-center align-content-center"
                      >
                        <img style={{ width: '30px',height:'30px' }} src={whatsapp_white} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                        <svg className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_4178_11253)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8651 13.403C14.4109 13.5886 14.1208 14.2997 13.8264 14.663C13.6754 14.8491 13.4954 14.8781 13.2634 14.7848C11.5586 14.1056 10.2517 12.968 9.31091 11.3991C9.15153 11.1558 9.18013 10.9636 9.37231 10.7377C9.65638 10.403 10.0136 10.0228 10.0904 9.57187C10.2611 8.57437 8.957 5.48016 7.23481 6.88219C2.27919 10.9205 15.5017 21.6309 17.8881 15.8381C18.5631 14.1961 15.6179 13.0945 14.8651 13.403ZM12.0001 21.9037C10.2475 21.9037 8.52294 21.4378 7.01309 20.5556C6.77075 20.4136 6.47778 20.3761 6.20684 20.4497L2.92606 21.3502L4.06888 18.8325C4.2245 18.4898 4.18466 18.0909 3.96481 17.7863C2.74231 16.0917 2.09591 14.0911 2.09591 12C2.09591 6.53859 6.53872 2.09578 12.0001 2.09578C17.4615 2.09578 21.9039 6.53859 21.9039 12C21.9039 17.4609 17.4611 21.9037 12.0001 21.9037ZM12.0001 0C5.38325 0 0.000125453 5.38312 0.000125453 12C0.000125453 14.3278 0.661063 16.5633 1.91684 18.5034L0.0938754 22.5183C-0.0744058 22.8891 -0.0129995 23.3231 0.250438 23.632C0.452938 23.8687 0.745907 24 1.04825 24C1.72419 24 5.40997 22.8417 6.34794 22.5844C8.08184 23.512 10.0267 24 12.0001 24C18.6165 24 24.0001 18.6164 24.0001 12C24.0001 5.38312 18.6165 0 12.0001 0Z" fill="#247034" />
                          </g>
                          <defs>
                            <clipPath id="clip0_4178_11253">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span style={{ fontFamily: "Raleway, sans-serif",marginTop:'5px',fontWeight:'500' }}>Support/Feedback</span>
                      </span>
                    )}
                  </Button>
                </a>
                <Button
                  className="btn mb-lg-auto mb-md-auto btn-radius"
                  type="submit"
                  // fullWidth
                  onClick={() => {
                    history.push('/join');
                  }}
                  variant="contained"
                  style={{
                    border: '1px solid #247034',
                    backgroundColor: '#247034',
                    color: Colors.white,
                  }}
                >
                  {load ? (
                    <CircularProgress
                      size={30}
                      style={{ color: Colors.white }}
                    />
                  ) : (
                    <span
                      style={
                        store.langIndex == 0
                          ? { fontFamily: "Raleway, sans-serif", fontSize: 12 }
                          : store.langIndex == 1
                            ? { fontFamily: "jameelNoori", fontSize: 10 }
                            : { fontFamily: "Arabic", fontSize: 10 }
                      }
                    >
                      <img style={{ width: '30px' }} src={handshake} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                      Join Team of Contributors
                    </span>
                  )}
                </Button>
              </div>
            </div>

            {/* App Bar for smaller screens */}
            <div className="d-block d-sm-none" >
              {/* Mobile Navbar */}
              <nav
                className="navbar navbar-inverse navbar-static-top p-0"
                role="navigation"
              >
                <div className="container p-0">
                  <div
                    className={`collapse navbar-collapse ${menu ? "show" : ""
                      }`}
                  >
                    <ul className="nav navbar-nav text-center">
                      <li className="mx-3">
                        <Link
                          to="/aboutus"
                          className={`${classes.link} text-decoration-none`}
                          style={{
                            color: "black",
                            fontFamily:
                              store.langIndex === 0
                                ? "Raleway, sans-serif"
                                : store.langIndex === 1
                                  ? "JameelNoori"
                                  : "Raleway, sans-serif",
                            fontSize:
                              store.langIndex === 0
                                ? 17
                                : store.langIndex === 1
                                  ? 15
                                  : 19,
                          }}
                        >
                          {TextTranslation.about_us[store.langIndex]}
                        </Link>
                        <hr className="m-1" />
                      </li>
                      <li className="mx-3">
                        <Link
                          to="/features"
                          className={`${classes.link} text-decoration-none`}
                          style={{
                            color: "black",
                            fontFamily:
                              store.langIndex === 0
                                ? "Raleway, sans-serif"
                                : store.langIndex === 1
                                  ? "JameelNoori"
                                  : "Raleway, sans-serif",
                            fontSize:
                              store.langIndex === 0
                                ? 17
                                : store.langIndex === 1
                                  ? 15
                                  : 19,
                          }}
                        >
                          {TextTranslation.features[store.langIndex]}
                        </Link>
                        <hr className="m-1" />

                      </li>
                      <li className="mx-3">
                        <Link
                          to="/contactus"
                          className={`${classes.link} text-decoration-none`}
                          style={{
                            color: "black",
                            fontFamily:
                              store.langIndex === 0
                                ? "Raleway, sans-serif"
                                : store.langIndex === 1
                                  ? "JameelNoori"
                                  : "Raleway, sans-serif",
                            fontSize:
                              store.langIndex === 0
                                ? 17
                                : store.langIndex === 1
                                  ? 15
                                  : 19,
                          }}
                        >
                          {TextTranslation.suggestion_contact_us[store.langIndex]}
                        </Link>
                        <hr className="m-1" />

                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>



        {/* Main Content */}
        <div className="container mt-3" >
          <div className="logo-custom">
            <div className="d-flex main_logo">
              <img
                src={logo}
                alt="Main Logo"
                className="main_logo_style img-fluid img-responsive"
              />
            </div>
          </div>
          <div className="row">
            {/* Left Side */}
            <div className="col-lg-6 col-md-12 mt-lg-5 mt-2">
              <div className={(classes.logo, "col-lg-12 col-md-12 mb-4")}
                style={
                  store.langIndex == 0
                    ? { fontFamily: "Raleway, sans-serif", }
                    : store.langIndex == 1
                      ? {

                        textAlign: "right",
                        fontFamily: "JameelNoori",
                        // fontSize: 16,

                      }
                      : {

                        textAlign: "right",
                        fontFamily: "Arabic",
                        // fontSize: 16,

                      }} >
                {/* <h1 className="pl-2 fontRaleway display-4">MIE</h1> */}
                <h2 className="" style={
                  store.langIndex == 0
                    ? { fontFamily: "Raleway, sans-serif", color: 'rgb(36, 112, 52)' }
                    : store.langIndex == 1
                      ? {

                        textAlign: "right",
                        fontFamily: "JameelNoori",
                        fontSize: 18,

                      }
                      : {

                        textAlign: "right",
                        fontFamily: "Arabic",
                        fontSize: 16,

                      }}>{TextTranslation.minhaj_islamic_encyclopedia[store.langIndex]}</h2>
                <p className="" style={
                  store.langIndex == 0
                    ? { fontFamily: "Raleway, sans-serif" }
                    : store.langIndex == 1
                      ? {

                        textAlign: "right",
                        fontFamily: "JameelNoori",
                        fontSize: 19,
                      }
                      : {

                        textAlign: "right",
                        fontFamily: "Arabic",
                        fontSize: 19,

                      }}>

                  {TextTranslation.overlay_text[store.langIndex]}
                </p>
              </div>
              <div className="main-buttons gap-2 justify-content-center align-items-center mb-4" >
                <Button
                  className="button-custom col-lg-6 col-md-6 col-12 btn mb-lg-auto mb-md-auto mb-3 btn-radius"
                  type="submit"
                  // fullWidth
                  onClick={() => {
                    history.push('/join');
                  }}
                  variant="contained"
                  style={{
                    backgroundColor: '#247034',
                    color: Colors.white,
                  }}
                >
                  {load ? (
                    <CircularProgress
                      size={30}
                      style={{ color: Colors.white }}
                    />
                  ) : (
                    <span
                      style={
                        store.langIndex == 0
                          ? { fontFamily: "Raleway, sans-serif", fontSize: 12 }
                          : store.langIndex == 1
                            ? { fontFamily: "jameelNoori", fontSize: 10 }
                            : { fontFamily: "Arabic", fontSize: 10 }
                      }
                      className=""
                    >
                      <img style={{ width: '30px' }} src={handshake} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                      Join Team of Contributors
                    </span>
                  )}
                </Button>
                <a target="_blank" style={{ color: '#247034' }} className="p-0 d-block col-lg-6 col-md-6 col-12 text-decoration-none" rel="noreferrer noopener" href='https://wa.link/0cxply'>
                  <Button target="_blank"
                    className="Feedback-btn btn btn-radius d-flex justify-content-center align-items-center "
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{
                      border: '1px solid #247034',
                      color: '#247034',
                      backgroundColor: 'transparent'
                    }}
                  >
                    {load ? (
                      <CircularProgress
                        size={30}
                        style={{ color: Colors.primary }}
                      />
                    ) : (
                      <span
                        style={
                          store.langIndex == 0
                            ? { fontFamily: "Raleway, sans-serif", fontSize: 12 }
                            : store.langIndex == 1
                              ? { fontFamily: "jameelNoori", fontSize: 10 }
                              : { fontFamily: "Arabic", fontSize: 10 }
                        }
                        className="d-flex justify-content-center align-content-center"
                      >
                        <img style={{ width: '30px',height:'30px' }} src={whatsapp_white} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                        <svg className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_4178_11253)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8651 13.403C14.4109 13.5886 14.1208 14.2997 13.8264 14.663C13.6754 14.8491 13.4954 14.8781 13.2634 14.7848C11.5586 14.1056 10.2517 12.968 9.31091 11.3991C9.15153 11.1558 9.18013 10.9636 9.37231 10.7377C9.65638 10.403 10.0136 10.0228 10.0904 9.57187C10.2611 8.57437 8.957 5.48016 7.23481 6.88219C2.27919 10.9205 15.5017 21.6309 17.8881 15.8381C18.5631 14.1961 15.6179 13.0945 14.8651 13.403ZM12.0001 21.9037C10.2475 21.9037 8.52294 21.4378 7.01309 20.5556C6.77075 20.4136 6.47778 20.3761 6.20684 20.4497L2.92606 21.3502L4.06888 18.8325C4.2245 18.4898 4.18466 18.0909 3.96481 17.7863C2.74231 16.0917 2.09591 14.0911 2.09591 12C2.09591 6.53859 6.53872 2.09578 12.0001 2.09578C17.4615 2.09578 21.9039 6.53859 21.9039 12C21.9039 17.4609 17.4611 21.9037 12.0001 21.9037ZM12.0001 0C5.38325 0 0.000125453 5.38312 0.000125453 12C0.000125453 14.3278 0.661063 16.5633 1.91684 18.5034L0.0938754 22.5183C-0.0744058 22.8891 -0.0129995 23.3231 0.250438 23.632C0.452938 23.8687 0.745907 24 1.04825 24C1.72419 24 5.40997 22.8417 6.34794 22.5844C8.08184 23.512 10.0267 24 12.0001 24C18.6165 24 24.0001 18.6164 24.0001 12C24.0001 5.38312 18.6165 0 12.0001 0Z" fill="#247034" />
                          </g>
                          <defs>
                            <clipPath id="clip0_4178_11253">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      {/* Support/Feedback */}
                      <span style={{ fontFamily: "Raleway, sans-serif",marginTop:'5px' }}>Support/Feedback</span>

                      </span>
                    )}
                  </Button>
                </a>
              </div>
              <div className="mt-4 text-start QR-code">
                <h4 className="text-start ms-4" style={{ fontFamily: "Raleway, sans-serif" }}>Scan this code</h4>
                <div className="d-flex justify-content-start">
                  <img src={Discord_QR} alt="QR Code 2" width="100" className="mx-2" />
                  <img src={Whatapp_QR} alt="QR Code 1" width="100" className="mx-2" />
                </div>
                <h4 style={{ fontFamily: "Raleway, sans-serif" }} className="text-start mt-1 d-flex justify-content-start align-items-center">
                  <img style={{ width: '30px' }} src={whatsapp_black} className="img-fluid img-responsive mt-0 pt-0 w-5 mx-2" />
                  +923007711148
                </h4>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-lg-6 col-md-12 text-center">
              <div className="overlap">

                {/* <img src="main-image.png" alt="Main" className="img-fluid mb-4" /> */}

                <img src={Mobiles2} style={{ width: '75%' }} className="img-fluid " />
                <h5 style={{ fontFamily: "Raleway, sans-serif !imortant"}}>Download Minhaj.app</h5>
                <div className="d-flex justify-content-center">
                  <div className="col-lg-12 col-md-12 col-12 mb-3 d-flex justify-content-center align-items-center">
                    <div className="col-lg-8 col-8 col-md-8 d-flex justify-content-center m-auto m-lg-0">
                      <div className="col-lg-4 col-6 col-md-6 p-lg-1 p-md-1 p-1">
                        <a target="_blank" rel="noreferrer noopener" href="https://play.google.com/store/apps/details?id=minhaj.islamic.encyclopedia" >
                          <img src={GoogleStore} className="img-responsive img-fluid" />
                        </a>
                      </div>
                      <div className="col-lg-4 col-6 col-md-6 p-lg-1 p-md-1 p-1">
                        <a target="_blank" rel="noreferrer noopener" href="https://apps.apple.com/pk/app/minhaj-islamic-encyclopedia/id1609248178" >
                          <img src={AppStore} className="img-responsive img-fluid" />
                        </a>
                      </div>
                      <div className="col-lg-4 col-6 col-md-6 p-lg-1 p-md-1 p-1">
                        <a target="_blank" rel="noreferrer noopener" href="https://appgallery.huawei.com/app/C109393717" >
                          <img src={HuaweiAppStore} className="img-responsive img-fluid" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Social Media Links */}
                <div className="social-links-main  justify-content-center align-content-center">
                  {/* <div className="col-lg-4 col-12 mt-lg-0 mt-4  d-flex justify-content-center align-content-center"> */}
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href='https://www.instagram.com/minhaj.app/'>
                      <img style={{ width: '30px' }} src={instagram} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href='https://fb.com/MinhajApp'>
                      <img style={{ width: '30px' }} src={facebook} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href='https://twitter.com/MinhajApp'>
                      <img style={{ width: '30px' }} src={twitter} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href='https://www.youtube.com/@MinhajApp'>
                      <img style={{ width: '30px' }} src={youtube} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href='https://www.linkedin.com/company/MinhajApp'>
                      <img style={{ width: '30px' }} src={linkedin} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  <div style={{ marginLeft: '15px' }}>
                    <a target="_blank" rel="noreferrer noopener" href=' https://www.tiktok.com/@minhajapp'>
                      <img style={{ width: '30px' }} src={tiktok} className="img-fluid img-responsive mt-0 pt-0 w-5" />
                    </a>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div >
      </div>
      {/* Footer */}
      <footer className="bg-lihgt w-100 d-flex justify-content-between align-items-center" >
        <div className="container d-flex justify-content-between align-items-center">
          <p style={{ fontFamily: "Raleway, sans-serif"}} className="my-2 p-0">Copyright &copy; minhaj.app. All Rights Reserved</p>
          <div className=" social-links-footer justify-content-center align-content-center">
            {/* <div className="col-lg-4 col-12 mt-lg-0 mt-4  d-flex justify-content-center align-content-center"> */}
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href='https://www.instagram.com/minhaj.app/'>
                <img style={{ width: '30px' }} src={instagram} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href='https://fb.com/MinhajApp'>
                <img style={{ width: '30px' }} src={facebook} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href='https://twitter.com/MinhajApp'>
                <img style={{ width: '30px' }} src={twitter} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href='https://www.youtube.com/@MinhajApp'>
                <img style={{ width: '30px' }} src={youtube} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href='https://www.linkedin.com/company/MinhajApp'>
                <img style={{ width: '30px' }} src={linkedin} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            <div style={{ marginLeft: '15px' }}>
              <a target="_blank" rel="noreferrer noopener" href=' https://www.tiktok.com/@minhajapp'>
                <img style={{ width: '30px' }} src={tiktok} className="img-fluid img-responsive mt-0 pt-0 w-5" />
              </a>
            </div>
            {/* </div> */}
          </div>
        </div>
      </footer >
    </>

  );
};

export default MainOverlay;
